module.exports = __webpack_public_path__ + "img/internet.0f7f8831.png";